// src/hooks/paxTypes/useRestorePaxType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restorePaxType as restorePaxTypeAPI } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useRestorePaxType = () => {
    const queryClient = useQueryClient();

    const { mutate: restorePaxType, isPending: isRestore } = useMutation({
        mutationFn: restorePaxTypeAPI,
        onSuccess: (res) => {
            const message = res?.message || "Pax type restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore pax type");
        },
    });

    return { restorePaxType, isRestore };
};

export default useRestorePaxType;